import { Box } from '@mui/system'
import React from 'react'
//import image from '../images/logo-m.png'

const LogoMain = () => {
  return (
    <Box width='100%'>
      <img src={'./images/logo-m.png'} alt="logo"  height='90px'/>
    </Box>
  )
}

export default LogoMain